<template>
  <div id="app" :style="isgrey == '1' ? { filter: 'grayscale(100%)' } : ''">
    <!-- <div class="wrapper"> -->

    <div class="head">
      <div style="width: 100%;background-color: #94080B;">
        <div class="w-1300 flex jc-b fff">
          <div>{{ lives.city }} - {{ lives.weather }}{{ lives.temperature }}° 风力{{ lives.windpower }}</div>
          <div class="flex jc-b">
            <div @click="setHome(this)" class="pointer">设为首页</div>
            <div class="ml20 pointer" @click="AddFavorite">收藏本站</div>
          </div>
        </div>
      </div>
      <div class="w-1300 flex jc-b black menusty">
        <div @click="gomenu('1')" :style="ismen == '1' ? { color: fcol } : ''">首页</div>
        <div @click="gomenu(item)" v-for="item in options.slice(0, 3)" :style="ismen == item.id ? { color: fcol } : ''">
          {{ item.title }}</div>
        <!-- <div @click="gomenu('3')" :style="ismen == '3' ? { color: fcol } : ''">学考中考</div>
            <div @click="gomenu('4')" :style="ismen == '4' ? { color: fcol } : ''">研考研招</div> -->
        <div style="line-height: 150px;">
          <img src="./assets/log.png" style="width: 230px; height: 58px;" />
        </div>
        <div @click="gomenu(item)" v-for="item in optionsSec.slice(3, 7)"
          :style="ismen == item.id ? { color: fcol } : ''">{{ item.title }}</div>
        <!-- <div @click="gomenu('6')" :style="ismen == '6' ? { color: fcol } : ''">自学考试</div>
            <div @click="gomenu('7')" :style="ismen == '7' ? { color: fcol } : ''">社会考试</div>
            <div @click="gomenu('8')" :style="ismen == '8' ? { color: fcol } : ''">普通话测试</div> -->
      </div>

    </div>
    <div class="conyent">
      <router-view></router-view>

    </div>
    <div class="footer">
      <Footer10 v-if="fcol == 'red'"></Footer10>
      <Footer v-else></Footer>
      <!-- <Footer></Footer> -->
    </div>
    <FiexCar10 v-if="fcol == 'red'" />
    <FiexCar v-else></FiexCar>
    <!-- </div> -->
  </div>
  <!-- -->
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { ref, onBeforeMount, onMounted, watch } from 'vue'
import { useRouter, useRoute } from "vue-router";
import Footer from "@/components/footer.vue"
import Footer10 from "@/components/footer10.vue"
import FiexCar from "@/components/fiexCar.vue"
import FiexCar10 from "@/components/fiexCar10.vue"
import { managerlistConfig, categorylistAll, restapi } from "@/api/demo"
import store from '@/store';
const route = useRoute();
const router = useRouter()
let ismen = ref('1')
let fcol = ref('#1970D0')
let isgrey = ref()
let options = ref([])
let optionsSec = ref([])
onBeforeMount(() => { })
watch(
  () => route.query.title,
  (newPath, oldPath) => {
    // 路由变化，执行相应操作
    if (route.query.title) {
      options.value.map(v => {
        if (v.title == route.query.title) {
          ismen.value = v.id
        }
      })
      if (route.query.title == 'search') {
        ismen.value = 'search'
      }
    } else {
      ismen.value = 1
    }
  }
)
let lives = ref({})
onMounted(() => {
  restapi().then(res => {
    if (res.lives) {
      lives.value = res.lives[0]
    }
  })
  init()
  managerlistConfig({ type: "color" }).then(res => {
    if (res.code == 100000) {
      res.data.map(v => {
        if (v.name == 'grey') {
          isgrey.value = v.intValue.toString()
        }
        if (v.name == 'red') {
          // red.value = v.intValue.toString()
          if (v.intValue == '1') {
            // router.push('/')
            fcol.value = 'red'
            store.commit('uppc10', true)

          } else {
            // router.push('/')
          }
        }
      })

    } else {
      ElMessage.error(res.description);
    }
  })

})
const init = async () => {
  await categorylistAll({
    pageNum: 1,
    pageSize: 10,
  }).then(res => {
    if (res.code == 100000) {
      let arr = []
      res.data.childCategory.map(v => {
        if (v.identify != '1') {
          options.value = res.data.childCategory
          optionsSec.value = res.data.childCategory
        } else {
          arr.push(v)
        }
        store.commit('upMenulist', arr)
      })

    } else {
      ElMessage.error(res.description);
    }
  })
  options.value.map(v => {
    if (v.title == route.query.title) {
      ismen.value = v.id
    }
  })
}
const gomenu = (t) => {
  if (t == '1') {
    router.push('/')
    ismen.value = t
  } else {
    ismen.value = t.id
    router.push({ name: 'adult', query: { fid: t.id, title: t.title } })
  }
}

const setHome = (obj, url = window.location.href) => {
  try {
    obj.style.behavior = 'url(#default#homepage)';
    obj.setHomePage(url);
  } catch (e) {
    if (window.netscape) {
      try {
        netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect');
      } catch (e) {
        alert('抱歉，此操作被浏览器拒绝！\n\n请在浏览器地址栏输入“about:config”并回车\n\n然后将[signed.applets.codebase_principal_support]的值设置为true，双击即可。');
      }
      var prefs = Components.classes['@mozilla.org/preferences-service;1'].getService(Components.interfaces.nsIPrefBranch);
      prefs.setCharPref('browser.startup.homepage', url);
    } else {
      alert('抱歉，您所使用的浏览器无法完成此操作。\n\n您需要手动将【' + url + '】设置为首页。');
    }
  }
}

const AddFavorite = () => {
  let url = window.location.href
  let title = '宁波市教育考试院'
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("360se") > -1) {
    alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
  }
  else if (ua.indexOf("msie 8") > -1) {
    window.external.AddToFavoritesBar(url, title); //IE8
  }
  else if (document.all) {//IE类浏览器
    try {
      window.external.addFavorite(url, title);
    } catch (e) {
      alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
    }
  }
  else if (window.sidebar) {//firfox等浏览器；
    window.sidebar.addPanel(title, url, "");
  }
  else {
    alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
  }

}
</script>

<style scoped>
html,
body {
  height: 100%;
}

.wrapper {
  position: relative;
}

.menusty {
  font-size: 16px;
  /* font-family: 宋体; */
  font-family: Source Han Serif CN VF, Source Han Serif CN VF;
  font-weight: 800;
  line-height: 100px;
  height: 100px;
  cursor: pointer;
}

.head {
  width: 100%;
  height: 136px;
  background-color: #ffffff;

  line-height: 36px;
  /* flex: 0; */
}

.w-1300 {
  width: 1300px;
  margin: 0 auto;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; */
  background-color: #fafbfc;
  /* height: 1400px; */
  min-height: 100%;
  /* 2. 需要将容器的高度设置成100% */
  position: relative;
  /* 3. 容器的position设置为relative，给子元素定位提供基点 */

}

.conyent {
  width: 100%;
  /* height: 1450px; */
  /* flex: 1; */
}

.footer {
  /* position: relative;
  bottom: 0; */
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  text-align: center;
  /* flex: 0; */
  /* padding: 15px 0; */
}
</style>
